import axios from 'axios';

export async function getStats(radiantPick,direPick,radiantName,direName, tournamentID){

    const isAuthDisabled = window?.RUNTIME_CONFIG?.IS_AUTH_DISABLED === '1'
    
    const token = isAuthDisabled ? 'temporary_disabled' : localStorage.getItem('ggs_token');

    if(!token) { 
      return {
        isNeedAuth: true,
      }
    }

    let request = await axios.post('/getstats',{
      radiantPick,
      direPick,
      radiantName,
      direName,
      tournamentID
    }, {
      headers: {
        'Authorization': token,
      }
    })
    let data = request.data;
    return data;
}